import React, { SVGProps } from 'react';
import { formatYAxisTickWithCustomFormat } from '../../../utils/formatting';
import {
  IMeasureDisplayFormatFieldsFragment,
  Maybe,
} from '../../../utils/apollo/graphqlSchema';
import { theme } from '../../../styles/theme';

interface IProps extends SVGProps<SVGTextElement> {
  measureDisplayFormat: Maybe<IMeasureDisplayFormatFieldsFragment>;
  forcePercent?: boolean;
  payload?: any;
}

export default ({
  x,
  y,
  textAnchor,
  measureDisplayFormat,
  forcePercent,
  payload: { value },
}: IProps) => {
  const parsedValue = formatYAxisTickWithCustomFormat(
    value,
    measureDisplayFormat,
    forcePercent,
  );

  return (
    <text
      x={x}
      y={y}
      textAnchor={textAnchor}
      fill={theme.colors.secondary600}
      fontWeight={400}
      fontSize={10}
    >
      <tspan x={x} dy={'0.355em'}>
        {parsedValue}
      </tspan>
    </text>
  );
};
